<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">

                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Bem-vindo, {{ $page.props.user.name }}
                </h2>
            </div>
        </template>
        <div class="py-12 pt-12 pb-6">
            <flash :timeout="5000"/>
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                    <div class="md:grid md:grid-cols-10 md:gap-6">
                        <div class="col-span-8">
                            <div class="w-1/2">
                                <div class="text-gray-700 font-medium text-sm text-left lg:text-left px-2">
                                    {{ $page.props.activeAccount.name }}
                                </div>
                                <div class="font-semibold text-gray-800 text-lg text-left lg:text-left px-2">
                                    {{ customer.name }}<br/>
                                    <span class="text-xs">Banco: </span><br/>{{ $page.props.activeAccount.bank.id }} -
                                    {{ $page.props.activeAccount.bank.name }}<br/>
                                    <div class="flex gap-8">
                                        <div>
                                            <span class="text-xs">Agência: </span><br/>{{
                                                $page.props.activeAccount.agency
                                            }}<br/>
                                        </div>
                                        <div>
                                            <span class="text-xs">Conta: </span><br/>{{
                                                $page.props.activeAccount.number
                                            }}-{{ $page.props.activeAccount.digit }}
                                        </div>
                                    </div>
                                </div>
                                <div class="text-gray-700 font-medium text-sm text-left lg:text-left my-4 px-2">
                                    <button @click="toClipboard"><i class="fas fa-copy"/>
                                        Clique aqui para copiar seus dados de transferência
                                    </button>
                                </div>
                            </div>
                        </div>
                        <balance />
                    </div>
                </div>
            </div>
        </div>

    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout'
import Welcome from './../../Jetstream/Welcome'
import ptBR from 'vuejs-datepicker/dist/locale'
import Button from "../../Jetstream/Button";
import Balance from "../../Helpers/Balance";
import Flash from "../../Helpers/Flash";

export default {
    components: {
        Flash,
        Balance,
        Button,
        AppLayout,
        Welcome,
    },
    props: ['customer', 'errors', 'pix_keys'],
    data() {
        return {
            ptBR: ptBR
        }
    },
    methods: {
        toClipboard: function () {
            let text =
                'Estes são os dados para transferência\n\n';
            text += `${this.customer.name}\n`;
            text += `${this.customer.owner.customer_type === 'PF' ? 'CPF' : 'CNPJ'}: ${this.customer.federal_document}\n`;
            text += `Número do banco: ${this.$page.props.activeAccount.bank.id} ${this.$page.props.activeAccount.bank.name}\n`;
            text += `Agência: ${this.$page.props.activeAccount.agency}\n`;
            text += `Conta: ${this.$page.props.activeAccount.number}-${this.$page.props.activeAccount.digit}\n`;
            if (this.pix_keys.length > 0){
                text += this.pix_keys.length == 1 ? `\nMinha chave PIX:\n`:`\nMinhas chaves PIX:\n`;
                this.pix_keys.forEach(element => {
                    text += `\t\u2022 ${element.tipoChave}: ${element.key}\n`;
                });
            }
            this.$clipboard(text);
            this.$toast.open({
                message: 'Seus dados foram copiados para a área de transferência',
                type: 'success',
                duration: 5000,
                position: 'top-right'
            });
        }
    }
}
</script>
